module.exports = __webpack_public_path__ + "static/media/grosse_hoeckerschrecke.7ce39a63.mp3";